export default __webpack_public_path__ + "static/right-50026d22eb789309aeda494ab6eb5308.png";